import { css } from 'lit';

export const style = css`
  .wrapper {
    max-width: var(--sbkCoreContentAreaBodyMaxWidth);
  }

`;